import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';

import Introduction from './Introduction';
import Navigation from './Navigation';
import Reasons from './Reasons';
import MemberQuotes from './MemberQuotes';
import SignUp from './SignUp';
import ContactMe from './ContactMe';
import LearnMore from './LearnMore';

import './index.css';

class LandingPage extends Component {
  render() {
    const {
      IntroduksjonSeksjon,
      MedlemsfordelerSeksjon,
      MedlemsreferanserSeksjon,
      BliMedlemSeksjon,
      KontaktMegSeksjon,
      DokumentSeksjon,
      history,
    } = this.props;

    return (
      <div>
        <Introduction {...IntroduksjonSeksjon} history={history} />
        <Navigation
          antallFordeler={MedlemsfordelerSeksjon.medlemsfordeler.length}
        />
        <Reasons {...MedlemsfordelerSeksjon} />
        <MemberQuotes {...MedlemsreferanserSeksjon} />
        <Container text>
          <SignUp {...BliMedlemSeksjon} history={history} />
          <ContactMe {...KontaktMegSeksjon} />
          <LearnMore {...DokumentSeksjon} />
        </Container>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/LandingPage/index.js